<div class="admin-update-guidelines">
  <div class="heading">
    <div style="display: flex">
      <div class="admin_header">
        <em
          class="bi bi-person"
          style="font-size: 1.3rem; margin-right: 0.6vw"
        ></em>
        Admin
      </div>
      <div class="edit-text">
        <div>Edit Mode</div>
      </div>
    </div>
    <div class="section-header">Guidelines Library</div>
    <div
      style="
        margin-right: 2vw;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: flex-end;
        height: 9vh;
      "
    >
      <!-- <button (click)="moveToSetUpScreen()" class="my-clear-button">
        Create New Planogram
      </button> -->

      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <!-- <button
          style="margin-right: 7px"
          (click)="changeMinimumFacings()"
          class="my-red-button save_button"
        >
          Minimum Facings: {{ minimum_facings ? minimum_facings : "" }}
          <em
            class="bi bi-pencil"
            style="
              font-size: 0.9rem;
              font-weight: 900;
              cursor: pointer;
              margin-left: 10px;
            "
          ></em>
        </button> -->
        <button
          (click)="saveAllLockedGuidelines()"
          class="my-red-button save_button"
        >
          Save
        </button>
      </div>
      <div style="font-size: 0.6vw; font-style: italic; padding: 0.3vh">
        * Click "Save" to lock highlighted guidelines
      </div>
    </div>
  </div>
  <div style="height: 81vh; overflow: auto">
    <table
      class="update-guidelines-table"
      #mytable
      [dataSource]="dataSource"
      mat-table
    >
      <ng-container matColumnDef="channel">
        <th mat-header-cell *matHeaderCellDef>
          <mat-form-field class="filter-dropdown">
            <mat-label class="label-heading">Channel:</mat-label>
            <mat-select
              [(ngModel)]="selectedChannel"
              (selectionChange)="onSelectionChannelCoolerChange()"
              multiple
              class="filter-select"
            >
              <mat-option>
                <mat-checkbox
                  class="mat-accent"
                  [checked]="allChannelsSelected"
                  (change)="toggleAllChannels()"
                  (click)="$event.stopPropagation()"
                >
                  All
                </mat-checkbox>
              </mat-option>
              <mat-option *ngFor="let channel of channels" [value]="channel">
                <mat-checkbox
                  class="mat-accent"
                  [checked]="selectedChannel.includes(channel)"
                >
                  {{ channel }}</mat-checkbox
                >
              </mat-option>
            </mat-select>
          </mat-form-field>
        </th>
        <td mat-cell *matCellDef="let data">{{ data.channel }}</td>
      </ng-container>
      <ng-container matColumnDef="cooler">
        <th mat-header-cell *matHeaderCellDef>
          <mat-form-field class="filter-dropdown">
            <mat-label class="label-heading">Cooler:</mat-label>
            <mat-select
              [(ngModel)]="selectedCooler"
              (selectionChange)="onSelectionChannelCoolerChange()"
              multiple
              class="filter-select"
            >
              <mat-option>
                <mat-checkbox
                  class="mat-accent"
                  [checked]="allCoolerSelected"
                  (change)="toggleAllCoolers()"
                  (click)="$event.stopPropagation()"
                  >All
                </mat-checkbox></mat-option
              >
              <mat-option *ngFor="let cooler of coolers" [value]="cooler">
                <mat-checkbox
                  class="mat-accent"
                  [checked]="selectedCooler.includes(cooler)"
                  >{{ cooler }}</mat-checkbox
                ></mat-option
              >
            </mat-select>
          </mat-form-field>
        </th>
        <td mat-cell *matCellDef="let data">{{ data.cooler_type }}</td>
      </ng-container>
      <ng-container
        *ngFor="let guideline of guidelinesColumn; let i = index"
        [matColumnDef]="guideline"
      >
        <th mat-header-cell *matHeaderCellDef></th>
        <td
          style="width: 18%; padding: 2vh 1vh"
          mat-cell
          *matCellDef="let data; let index = index"
        >
          <div class="guidelines-box-container">
            <div
              class="guidelines-box"
              [ngStyle]="{
                border: data.can_semi_locked == i + 1 ? '2px solid #E61A27' : ''
              }"
            >
              <div class="header">{{ guideline }}</div>
              <div style="padding-top: 1vh; display: flex; gap: 5%">
                <img
                  (click)="openGuidelinesData(data.guidelines[i])"
                  style="height: 4.5vh"
                  src="../../assets/pin_icon.png"
                />
                <div class="content-text">
                  <div style="font-weight: 600; font-size: 0.9vw">
                    OTV -
                    <span *ngIf="data.guidelines[i]"
                      >{{ data.guidelines[i] ? "₹" : "" }}
                      {{ data.guidelines[i].cooler_value }}</span
                    >
                  </div>
                  <div style="font-size: 0.9vw">
                    HCCB -
                    <span *ngIf="data.guidelines[i]">{{
                      displayDate(data.guidelines[i].updated_at)
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="button-container">
                <button
                  (click)="
                    viewVersionedGuidelines(
                      data.channel,
                      data.cooler_type,
                      i,
                      data.locked_guidelines,
                      data.selectedBottler,
                      data.guidelines[i]?.planogram_id,
                      guideline
                    )
                  "
                  class="update"
                  mat-flat-button
                  color="warn"
                >
                  Update
                </button>
                <img
                  (click)="
                    updateLockedGuideline(
                      data.channel,
                      data.cooler_type,
                      data.selectedBottler,
                      i + 1
                    )
                  "
                  style="height: 3.5vh"
                  [src]="
                    data.locked_guidelines === i + 1
                      ? '../../assets/red_lock.png'
                      : '../../assets/grey_unlock.png'
                  "
                  alt=""
                />
              </div>
            </div>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="dropdown">
        <th mat-header-cell *matHeaderCellDef>Bottling Units</th>
        <td mat-cell *matCellDef="let data; let i = index">
          <div class="compare-dropdown-section">
            <div>
              <mat-form-field class="filter-dropdown">
                <mat-select
                  [value]="data.selectedBottler"
                  class="planogram-filter-select filter-select"
                >
                  <mat-option
                    *ngFor="let bottler of data.bottlers"
                    (click)="onBottlerSelectionChange(i, bottler)"
                    [value]="bottler"
                  >
                    <mat-checkbox
                      class="mat-accent"
                      [checked]="data.selectedBottler == bottler"
                      >{{ bottler }}
                    </mat-checkbox></mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
            <button
              (click)="comparePlanograms(data.guidelines)"
              class="my-red-button compare-button"
            >
              Compare
            </button>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: columns"></tr>
    </table>
  </div>
  <app-loader [is_show_loader]="(is_show_loader | async)!"></app-loader>
</div>
